<template>
  <div>
    <v-list dense shaped color="transparent">
      <v-list-item-group color="primary">
        <v-list-item to="/cl_prices/calculator">
          <v-list-item-icon class="mx-0">
            <v-icon color="primary" small>mdi-calculator</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Price Calcs</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/cl_prices/pricelist">
          <v-list-item-icon class="mx-0">
            <v-icon color="primary" small>mdi-currency-usd</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>CL Price List</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/cl_prices/rebateList">
          <v-list-item-icon class="mx-0">
            <v-icon color="primary" small>mdi-cash-100</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Rebate List</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!-- <v-list-item to="/cl_prices/settings">
          <v-list-item-icon class="mx-0">
            <v-icon color="primary" small>mdi-cog</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Calculator Settings</v-list-item-title>
          </v-list-item-content>
        </v-list-item> -->
      </v-list-item-group>
    </v-list>
  </div>
</template>

<script>
// import Name from "../dir/file";

export default {
  name: "PricesMenuBtns",
  props: {},
  data: function () {
    return {};
  },
  methods: {},
  computed: {},
};
</script>

<style scoped></style>
